import React, { useContext } from "react";
import { usePageRefresh } from "../tools";
import { FilterArea, StackedBarchart, OverheadsDataTable, DataQualityLegend } from "@sia/style-guide";
import { generateTableCells, parseChartData } from "./data/dataParsing";
import { MasterKeyContext } from "contexts/MasterKeyContext";
import { generateWorkingHoursTableHeader, tooltipGenerator } from "./helpers";
import "./WorkingHoursPage.scss";

export default function WorkingHoursPage({ translate, filters, setFilters, data, selectedTab, setSelectedTab }) {
  const OVERHEADS_PAGE_TAB_INDEX = 2;
  usePageRefresh(selectedTab, OVERHEADS_PAGE_TAB_INDEX, setSelectedTab);
  const { isMasterKeyValid } = useContext(MasterKeyContext);

  let stackedBarchartData = parseChartData(data?.data);
  if (stackedBarchartData.length === 0) {
    return null;
  }

  let tableHeaderRows = generateWorkingHoursTableHeader(data.data, translate, isMasterKeyValid);
  let tableData = generateTableCells(data.data, isMasterKeyValid, data.labels);

  return (
    <div className="benchmarking-salary-container sia-padding-02-left sia-padding-02-right" id="sia-working-hours-page">
      <p className="title sia-text-15 sia-padding-06-top sia-padding-06-bottom">{translate("benchmarking.evaluations.working-hours.title")}</p>
      <FilterArea
        translate={translate}
        initialFilters={filters}
        onFiltersUpdate={(filterAreaState) => {
          setFilters((state) => ({ ...state, filters: filterAreaState, newest: true }));
        }}
      />
      <StackedBarchart
        translate={translate}
        bandWidth={50}
        data={stackedBarchartData}
        isPercentage={false}
        options={{
          gradients: {
            ownValue: ["#e41a11"],
            average: ["#000000"],
          },
        }}
        refIndex={0}
        tooltipGenerator={tooltipGenerator}
      />
      <div className="sia-padding-05-top">
        <OverheadsDataTable headerRows={tableHeaderRows} dataRows={tableData} />
        <DataQualityLegend translate={translate} />
      </div>
    </div>
  );
}
